jQuery(function ($) {
  // Add smooth scroll to anchor links. Just add the "smooth" class to your links
  $('a.smooth[href*="#"]:not([href="#"])').click(function () {
    if (
      location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
      location.hostname == this.hostname
    ) {
      var target = $(this.hash);
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
      if (target.length) {
        $("html,body").animate(
          {
            scrollTop: target.offset().top,
          },
          300
        );
        return false;
      }
    }
  });

  // Navbar Submenu Dropdown Links Click - Mobile
  $(".menu-toggle").on("click", function (e) {
    $(this).toggleClass("collapsed");

    var $subMenu = $(this).parent().next(".sub-menu");
    $subMenu.toggleClass("slideInUp animated show");

    return false;
  });

  // Sticky Navigation Bar
  var stickyToggle = function (sticky, stickyWrapper, scrollElement) {
    var stickyHeight = sticky.outerHeight();

    var stickyTop = stickyWrapper.offset().top + 50;
    if (scrollElement.scrollTop() >= stickyTop) {
      stickyWrapper.height(stickyHeight);
      sticky.addClass("is-sticky active");
    } else {
      sticky.removeClass("is-sticky active");
      stickyWrapper.height("auto");
    }
  };

  // Find all data-toggle="sticky-onscroll" elements
  $('[data-toggle="sticky-onscroll"]').each(function () {
    var sticky = $(this);
    var stickyWrapper = $("<div>").addClass("sticky-wrapper"); // insert hidden element to maintain actual top offset on page
    sticky.before(stickyWrapper);
    sticky.addClass("sticky");

    // Scroll & resize events
    $(window).on("scroll.sticky-onscroll resize.sticky-onscroll", function () {
      stickyToggle(sticky, stickyWrapper, $(this));
    });

    // On page load
    stickyToggle(sticky, stickyWrapper, $(window));
  });

  // Navbar Toggler
  $(".nav-toggler").on("click", function (e) {
    $(".nav-search-icon").removeClass("nav-search-icon--close");
    $("#search-box").css("display", "none");
    $(this).toggleClass("is-active");
    $("div.nav-collapse").toggleClass("show");
    $(".site-header").toggleClass("menu-is-active");
  });

  // Detect if dropdown navigation would go off screen and reposition it
  $(".menu-item-has-children li").on("mouseenter mouseleave", function (e) {
    if ($("ul", this).length) {
      var elm = $("ul:first", this);
      var off = elm.offset();
      var l = off.left;
      var w = elm.width();
      var docH = $(".site-container").height();
      var docW = $(".site-container").width();

      var isEntirelyVisible = l + w <= docW;

      if (!isEntirelyVisible) {
        $(this).find("ul.sub-menu").eq(0).addClass("edge");
      } else {
        $(this).find("ul.sub-menu").eq(0).removeClass("edge");
      }
    }
  });

  // Menu Search Trigger
  $(".nav-search-icon").click(function (e) {
    e.stopPropagation();
    e.preventDefault();
    $(".nav-toggler").removeClass("is-active");
    $(".nav-collapse").removeClass("show");
    $(this).toggleClass("nav-search-icon--close");
    $("#search-box").fadeToggle(350);
    $("#search-box .search-field").focus();
  });

  // Hide Menu Search Trigger on Document Click
  $(document).on("click", function (event) {
    var eventClick = $(event.target).closest("#search-box").length;
    if (!eventClick) {
      $("#search-trigger").removeClass("nav-search-icon--close");
      $("#search-box").fadeOut(350);
    }
  });

  // Accordion
  $(document).ready(function () {
    $(".set > span.acc-trigger").on("click", function (e) {
      e.preventDefault();
      if ($(this).hasClass("acc-active")) {
        $(this).removeClass("acc-active");
        $(this).siblings(".acc-content").slideUp(200);
        // $(".set > a i").removeClass("fa-minus").addClass("fa-plus");
      } else {
        // $(".set > a i").removeClass("fa-minus").addClass("fa-plus");
        // $(this).find("i").removeClass("fa-plus").addClass("fa-minus");
        $(".set > span.acc-trigger").removeClass("acc-active");
        $(this).addClass("acc-active");
        $(".acc-content").slideUp(200);
        $(this).siblings(".acc-content").slideDown(200);
      }
    });
  });
  // Content Tabs
  $("ul.tabs li").click(function () {
    var tab_id = $(this).attr("data-tab");

    $("ul.tabs li").removeClass("current");
    $(".tab-content").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
  });

  // Back To Top Button
  $(window).scroll(function () {
    if ($(this).scrollTop() > 200) {
      $(".backtotop").fadeIn();
    } else {
      $(".backtotop").fadeOut();
    }
  });

  $(".backtotop").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 600);
    return false;
  });




// Woocommerce
  // Mini Cart
  $(".woo-shopping-cart__icon").click(function (e) {
    e.stopPropagation();
    e.preventDefault();
    $(".woo-side-cart").addClass("show");
    $(".site-overlay").addClass("is-active");
    $(document.body).css("overflow", "hidden");
  });

  $("body").on("added_to_cart", function () {
    $(".woo-side-cart").addClass("show");
    $(".site-overlay").addClass("is-active");
    $(document.body).css("overflow", "hidden");
  });

  $("div#close-woo-side-cart").click(function (e) {
    e.stopPropagation();
    e.preventDefault();
    $(".woo-side-cart").removeClass("show");
    $(".site-overlay").removeClass("is-active");
    $(document.body).css("overflow", "auto");
  });

  $(document).on("click", function (e) {
    if ($(e.target).closest(".woo-side-cart").length === 0) {
      $(".woo-side-cart").removeClass("show");
      $(".site-overlay").removeClass("is-active");
      $(document.body).css("overflow", "auto");
    }
  });

  // Woocommerce - "Update Cart" Automatically on Quantity Change
  var cartTimeout;

  $(".woocommerce").on("change", "input.qty", function () {
    if (cartTimeout !== undefined) {
      clearTimeout(cartTimeout);
    }
    cartTimeout = setTimeout(function () {
      $("[name='update_cart']").trigger("click");
    }, 75); // 1 second delay, half a second (500) seems comfortable too
  });
});
